require("./brokerCustomWalletSideBar.scss");
const PropTypes = require('prop-types');
// @ vendor
const React = require("react");
// @ commons
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');
// @ components
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
// @ constants
// @utils
const { formatText, FormattedText } = require('core/i18n').i18n;


class BrokerCustomWalletSideBar extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { brokerCustomWalletNotifications } = this.props;
        const hasUnconsolidatedContract = brokerCustomWalletNotifications ? brokerCustomWalletNotifications.get('hasUnconsolidatedContract') : false;
        const cwBoxTitle = formatText('brokerCustomWallet-createImportantTitle');
        let cwBoxUnconsolidatedParagraph;

        if(hasUnconsolidatedContract) {
            cwBoxUnconsolidatedParagraph = (
                <div className="custom-wallet-sidebar__info-paragraph">
                    <FormattedText className="custom-wallet-sidebar__info-paragraph--bullet" value="brokerCustomWallet-createImportantText4"/>
                </div>
            );
        }

        const cwBoxBody = (
            <div>
                <div className="custom-wallet-sidebar__info-icon">
                    <OKIconIllustrative icon="info" product="banking" />
                </div>
                <div className="custom-wallet-sidebar__info">
                    <div className="custom-wallet-sidebar__info-paragraph">
                        <FormattedText className="custom-wallet-sidebar__info-paragraph--bullet" value="brokerCustomWallet-createImportantText"/>
                    </div>
                    <div className="custom-wallet-sidebar__info-paragraph">
                        <FormattedText className="custom-wallet-sidebar__info-paragraph--bullet" value="brokerCustomWallet-createImportantText2"/>
                    </div>
                    {cwBoxUnconsolidatedParagraph}
                </div>
            </div>
        )

        return (
            <ContactInfoBox boxTitle={cwBoxTitle} boxBody={cwBoxBody} customClass="custom-wallet-sidebar__info-box"/>
        );
    }
}

BrokerCustomWalletSideBar.propTypes = {
    brokerCustomWalletNotifications: PropTypes.any.isRequired
};

module.exports = BrokerCustomWalletSideBar;
